import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import map from '../assets/img/svgmap.png';
import '../styles/Map.css';

gsap.registerPlugin(ScrollTrigger);

export const Map = () => {
  const titleRef = useRef(null);
  const officesRefs = useRef([]);
  const [isVisible, setIsVisible] = useState(false);
  const [titleAnimatedOnce, setTitleAnimatedOnce] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const mapSection = document.querySelector('.map-container');
      const mapTop = mapSection.offsetTop;

      if (scrollPosition + windowHeight >= mapTop + (mapSection.offsetHeight * 0.5)) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isVisible && !titleAnimatedOnce) {
      gsap.fromTo(titleRef.current, {
        opacity: 0,
        y: 30,
      }, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power3.out',
        onComplete: () => setTitleAnimatedOnce(true)
      });

      officesRefs.current.forEach((el) => {
        gsap.fromTo(el, {
          opacity: 0,
          y: 30,
        }, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 80%',
            end: 'bottom 20%',
            toggleActions: 'play none none none',
          }
        });
      });
    }
  }, [isVisible, titleAnimatedOnce]);

  return (
    <section className="h-auto relative map-container">
      <div className="md:ml-8 mx-auto max-w-[fit-content]">
        <h1
          className={`text-white leading-[2.5rem] z-30 text-[3.5rem] font-normal tracking-tight heading-map ${isVisible ? 'opacity-100' : 'opacity-0'}`}
          ref={titleRef}
        >
          Global agency
        </h1>
      </div>
      
      <div className="relative mt-8 w-full">
        <img src={map} alt="Map" className="w-full h-auto md:mt-2 mt-12 md:px-8 px-2 map-image" />

        <div className="absolute flex gap-x-2 map-point usa-offices">
          <div className='h-8 w-8 flex items-center justify-center dot_map border border-indigo-700 backdrop-blur-md text-white rounded-full'>8</div>
          <div ref={el => officesRefs.current[0] = el} className="offices -mt-4 flex items-center location mb-8 px-3 py-2 h-8 w-auto rounded-full backdrop-blur-xl z-20">
            <p className='p-white mt-[2px]'>U.S.A Offices</p>
          </div>
        </div>
        <div className="absolute map-point west-usa">
          <div className='h-8 w-8 flex items-center justify-center dot_map border border-indigo-700 backdrop-blur-md text-white rounded-full'>4</div>
        </div>
        <div className="absolute flex gap-x-2 map-point south-america">
          <div className='h-8 w-8 flex items-center justify-center dot_map border border-indigo-700 backdrop-blur-md text-white rounded-full'>3</div>
          <div ref={el => officesRefs.current[1] = el} className="offices -mt-4 flex items-center location mb-8 px-3 py-2 h-8 w-auto rounded-full backdrop-blur-xl z-20">
            <p className='p-white'>South America</p>
          </div>
        </div>
        <div className="absolute flex gap-x-2 map-point europe-offices">
          <div className='h-8 w-8 flex items-center justify-center dot_map border border-indigo-700 backdrop-blur-md text-white rounded-full'>5</div>
          <div ref={el => officesRefs.current[2] = el} className="offices -mt-4 flex items-center location mb-8 px-3 py-2 h-8 w-auto rounded-full backdrop-blur-xl z-20">
            <p className='p-white whitespace-nowrap'>Europe Offices</p>
          </div>
        </div>
        <div className="absolute map-point middle-east">
          <div className='h-8 w-8 flex items-center justify-center dot_map border border-indigo-700 backdrop-blur-md text-white rounded-full'>2</div>
        </div>
        <div className="absolute map-point russia">
          <div className='h-8 w-8 flex items-center justify-center dot_map border border-indigo-700 backdrop-blur-md text-white rounded-full'>3</div>
        </div>
      </div>
    </section>
  );
};

export default Map;